import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ResponseItemModel} from '../model/file/drag/responce/response-item.model';

@Injectable({ providedIn: 'root' })
export class GenericServerResponseHandlerService {

  constructor(private toasterService: ToastrService) {
  }

  handle(item: ResponseItemModel) {
    this.toasterService.show(item.message, null, null, 'toast-' + item.resultCode);
  }
}
